import React, { createContext } from 'react';
export const DefaultInteractiveElement = ({ customComponent, children, ...props }) => {
    const defaultComponent = props.href ? 'a' : 'button';
    const Component = customComponent || defaultComponent;
    return React.createElement(Component, { ...props }, children);
};
export const FrodorModulesContext = createContext({
    dir: 'ltr',
    preloadVideo: 'auto',
    InteractiveElement: DefaultInteractiveElement,
});
export const useFrodorModules = () => React.useContext(FrodorModulesContext);
export const FrodorModulesProvider = ({ children, dir = 'ltr', preloadVideo = 'auto', InteractiveElement = DefaultInteractiveElement, }) => {
    return (React.createElement(FrodorModulesContext.Provider, { value: { dir, preloadVideo, InteractiveElement } }, children));
};
